
import { Component, Vue, Watch } from "vue-property-decorator";
import { Loading, RigheSpedizioneList,  StatoWorkflow } from "@/components";
import { LavorazioneSlim, Spedizione } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';
import { truncate } from 'fs';
import dayjs, { Dayjs } from 'dayjs';
import { StatoSpedizione } from "@/models/enums/StatoSpedizioni";
import saveAs from "file-saver";

@Component({
    components: {
        Loading,
        RigheSpedizioneList
    }
})
export default class SpedizioneDettaglio extends Vue {

  private idRighe: string[] = [];
  private mostraHeader = true;
  private dialog = false;
  public inModifica = false;

  public spedizioneInEdit = {
        dataDDT: null,
        numeroColli: 0,
        numeroDDT: '',
        note: '',
    } as Spedizione;

  get spedizione(): Spedizione | undefined {
    return store.state.spedizioneCorrente;
  }
  public formatDateTime(date: Date): string {
      if (!date) return '';
      const formattedDate = dayjs(date).format('DD/MM/YYYY HH:mm');
      return formattedDate;
  }
  get iconClassByProgress(): string {
      return 'grey';
  }

  get statoLavorazioniAllineato(): boolean {
      return false;
  }

  get progressiGestibili(): boolean {
    let result = true;
    return result;
  }

  @Watch("$route.params.id", { immediate: true })
  async onIdChanged(newId: string, oldId: string) {
    if(oldId) {
        this.beforeDestroy();
    }
    store.commit(StoreMutations.SetSottotitoloPagina, newId);
    await store.dispatch(StoreActions.GetSpedizione, newId);
    if(this.spedizione) {
        this.idRighe = this.spedizione.righe.map(r => r.idLavorazione);
        store.dispatch(StoreActions.WatchNotificheGruppi);
    }
  }

  get loading() {
    return !store.state.ui.opzioniVisibili && store.state.loading && !this.dialog;
  }

  private beforeDestroy() {
      store.dispatch(StoreActions.UnwatchNotificheGruppi);
  }

  //MODIFICA SPEDIZIONE
  public inEditSpedizioneDateMenu: boolean=false;
  public inEditSpedizioneDataSpedizione: string = '';
  public inEditSpedizioneDataSpedizioneFormatted: string = '';

  get statiSpedizione(){
    return Object.values(StatoSpedizione);
  }

  public modifica(){
    this.inModifica = true;

    if(this.spedizione){
        this.spedizioneInEdit = {
            id: this.spedizione.id,
            idFornitore: this.spedizione.idFornitore,
            dataDDT: this.spedizione.dataDDT,
            note: this.spedizione.note,
            numeroColli: this.spedizione.numeroColli,
            numeroDDT: this.spedizione.numeroDDT,
            stato: this.spedizione.stato,
        } as Spedizione;

        this.inEditSpedizioneDataSpedizione = dayjs(''+this.spedizione.dataDDT).format("YYYY-MM-DD");
    }
  }

  public async aggiornaSpedizione(){
    if(this.inEditSpedizioneDataSpedizione){
            this.spedizioneInEdit.dataDDT = this.inEditSpedizioneDataSpedizione;
        }

        const convertedNumeroColli = +this.spedizioneInEdit.numeroColli;
        if(!Number.isNaN(convertedNumeroColli)){
            this.spedizioneInEdit.numeroColli = convertedNumeroColli;
        }

        this.spedizioneInEdit.righe = [];
        const esito = await store.dispatch(
            StoreActions.AggiornaSpedizione,
            this.spedizioneInEdit
        );
        if(esito){
            this.inModifica = false;
            await store.dispatch(StoreActions.GetSpedizione, this.spedizione?.id);
        }
  }

  parseDate (date: string): string {
        if (!date) return '';

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    formatDateForDatePicker (date: string): string {
        if (!date) return '';

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    @Watch('inEditSpedizioneDataSpedizione')
    onNewSpedizioneDataSpedizioneChange(): void {
        this.inEditSpedizioneDataSpedizioneFormatted = this.formatDateForDatePicker(this.inEditSpedizioneDataSpedizione)
    }

    //AGGIUNGI RIGA MANUALMENTE
    public addRigaManualmenteDialog: boolean = false;
    public searchLidText: string = "";
    get lavorazioneFound(): LavorazioneSlim {
        return store.state.uiSpedizione.lavorazionePerAggiuntaRiga;
    }
    get loadingRigaSpedizioneManualeDaLid(): boolean{
        return store.state.uiSpedizione.loading;
    }

    public async getLavorazioneDaLid(){
        await store.dispatch(StoreActions.GetLavorazionePerRigaSpedizioneDaLid, this.searchLidText);
    }

    public async addRigaSpedizione(){
        const idSpedizione = this.spedizione?.id;
        const idLavorazione = this.lavorazioneFound?.id;
        await store.dispatch(StoreActions.AggiungiRigaSpedizioneDaLavorazione, {idSpedizione, idLavorazione });
        this.addRigaManualmenteDialog = false;
    }

    //AGGIUNGI RIGA DA LETTORE BARCODE
    public isInBarCodeAcquisitionMode: boolean = false;
    public barCodeAcquisitionMode: boolean = true;

    public epcSearchText: string = "";

    public openAddLavorazioneManualmenteDialog () {
        this.epcSearchText = "";
        this.addRigaManualmenteDialog = true;
    }

    public keyPressHandler(event : KeyboardEvent){
        console.log(event.key);
        if(event.key == "Enter"){
            this.addRigaFromEPC();
        } else {
            this.epcSearchText += event.key;
        }
    }

    public setAcquisitionMode(){
        //Ha logica inversa in base alla visualizzazione
        this.barCodeAcquisitionMode = !this.barCodeAcquisitionMode;
        if(!this.barCodeAcquisitionMode)
        {
            this.isInBarCodeAcquisitionMode = true;
            this.epcSearchText = "";
            addEventListener("keypress", this.keyPressHandler);
        } else {
            this.isInBarCodeAcquisitionMode = false;
            removeEventListener("keypress", this.keyPressHandler);
        }
    }

    public async addRigaFromEPC(){

        const idSpedizione = this.spedizione?.id;
        console.log(this.epcSearchText);
        const searchText = (+this.epcSearchText).toString();
        this.epcSearchText = "";
        await store.dispatch(StoreActions.AggiungiRigaSpedizioneDaEpcLavorazione, {idSpedizione: idSpedizione, epcLavorazione: searchText });
        this.addRigaManualmenteDialog = false;
    }

    //DOWNLOAD PACKING LIST
    get csvLoading(){
        return store.state.uiSpedizione.csvLoading;
    }

    public async downloadCSVPackingList(){
        let data = await store.dispatch(StoreActions.DownloadCSVPackingList, this.spedizione?.id);
        if(data){
            saveAs(data, `spedizione_packing_list_${this.spedizione?.id}.csv`);
            await store.dispatch(StoreActions.GetSpedizione, this.spedizione?.id);
        }
    }

    public async downloadCSVPackingListExtended(){
        let data = await store.dispatch(StoreActions.DownloadCSVPackingListExtended, this.spedizione?.id);
        if(data){
            saveAs(data, `spedizione_packing_list_estesa_${this.spedizione?.id}.csv`);
            await store.dispatch(StoreActions.GetSpedizione, this.spedizione?.id);
        }
    }

    get totaliSpedizioni(): any {
        let totSped = 0;
        let totLav = 0;
        let totProgSped = 0;
        for(var indexRiga = 0;  indexRiga < (this.spedizione?.righe?.length || 0); indexRiga++){
            let riga = this.spedizione?.righe[indexRiga];
            if(riga){
                let tipoTaglia: any = riga.tipoTagliaDecodificato;
                let headersLength = 0;
                for (let index = 1; index <= 16; index++) {
                    const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
                    const valProp: string = tipoTaglia[nomeProp];

                    let end = valProp == undefined || valProp == '';
                    if(!end) {
                        headersLength++;
                    }
                }

                for (let index = 1; index <= headersLength; index++) {
                    const nomeProp = `qtaTaglia${index.toString().padStart(2, '0')}`;
                    const lavNomeProp = `lavQtaTaglia${index.toString().padStart(2, '0')}`;
                    const progSpedNomeProp = `progSpedTaglia${index.toString().padStart(2, '0')}`;

                    const quantityRiga = ((riga as any)[nomeProp] as number);
                    const quantityLavRiga = ((riga as any)[lavNomeProp] as number);
                    const quantityProgSpedRiga = ((riga as any)[progSpedNomeProp] as number);

                    totSped += quantityRiga;
                    totLav += quantityLavRiga;
                    totProgSped += quantityProgSpedRiga;

                }
            }
        }

        let totali = {
            totSped: totSped,
            totResiduo: totLav-totProgSped,
            color: "",
        }

        if(totSped == (totLav - totProgSped)){
            totali.color = "green";
        } else if(totSped > (totLav - totProgSped)){
            totali.color = "red";
        }

        return totali;
    }

}
